/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { styles } from '@carbon/elements';

export const ResultContainer = styled.div`
  padding: var(--cds-spacing-04);
  height: 100%;
  overflow-y: auto;
`;

export const ResultText = styled.pre`
  white-space: pre-wrap;
  word-break: break-word;
`;

export const WarningsList = styled.ul`
  list-style: none;
  word-break: break-word;
`;

export const WarningTitle = styled.span`
  font-weight: bold;
`;

export const Separator = styled.hr`
  margin: var(--cds-spacing-03) 0;
  border: 0;
  border-top: 1px solid var(--cds-border-subtle-01);
`;

export const ErrorTitle = styled.div`
  font-weight: bold;
  margin-bottom: var(--cds-spacing-03);
`;

export const ErrorText = styled.p`
  ${styles.legal01};
  font-family: 'IBM Plex Mono', monospace;
  word-break: break-word;
`;

export const EmptyStateText = styled.p`
  ${styles.legal01};
`;
